import * as React from 'react';
import { memo } from 'react';

import routes from 'defs/routes';

import Icon from 'components/atoms/Icon';
import UIAsset from 'components/atoms/UIAsset';
import HeaderNav from 'containers/molecules/HeaderNav';
import HeaderService from 'containers/molecules/HeaderService';
import LoginButton from 'containers/molecules/LoginButton';

export type HeaderIconType = 'overview' | 'calendar-day' | 'program' | 'user' | 'badge' | 'heart' | '';

export type HeaderTitleType = {
	icon: HeaderIconType;
	text: string;
	dayOfMonth?: number;
};
export type HeaderProps = {
	title?: HeaderTitleType;
	currentViewId?: string;
	onBack: Function;
	onTrigger: Function;
	showOffCanvasTrigger?: boolean;
	dayNumber?: number;
};

const hideArrowOnPages = [
	routes.deepLink.startProgram.id,
	routes.login.indexRoute.id,
	routes.anamnesis.indexRoute.id,
	routes.anamnesis.start.id,
	routes.anamnesis.selectCoach.id,
	routes.anamnesis.selectGender.id,
	routes.anamnesis.determineAge.id,
	routes.anamnesis.determineHeight.id,
	routes.anamnesis.determineWeight.id,
	routes.anamnesis.defineHealthTarget.id,
	routes.anamnesis.acceptHealthTarget.id,
	routes.anamnesis.selectActivityLevel.id,
	routes.anamnesis.verify.id,
	routes.anamnesis.disclaimer.id,
	routes.anamnesis.dsgvo.id,
	routes.dashboard.indexRoute.id,
];

export class Header extends React.Component<HeaderProps> {
	public static displayName = 'Header';
	public static defaultProps = {
		showOffCanvasTrigger: true,
	};

	public handleTrigger = (event) => {
		this.props.onTrigger(event);
	};

	public handleBack = (event) => {
		this.props.onBack(event);
	};

	public render() {
		const { title, showOffCanvasTrigger, currentViewId } = this.props;
		const showBackLink = !~hideArrowOnPages.indexOf(currentViewId!);

		return (
			<div className="o-header">
				<div className="o-header__bar js-o-header__bar">
					{showBackLink && (
						<a className="o-header__back" onClick={this.handleBack}>
							<Icon iconName="back" delegate="o-header__back" />
						</a>
					)}

					{showOffCanvasTrigger && (
						<div className="o-header__buttons">
							<div className="o-header__profile js-o-header__profile">
								<LoginButton setupLoginFlow />
							</div>
							<div className="o-header__trigger" onClick={this.handleTrigger}>
								<Icon iconName="menu" delegate="o-header__trigger" />
							</div>
						</div>
					)}

					{title && (
						<div className="o-header__title">
							<span className="o-header__title-text">
								<div className={title.icon ? 'o-header__title-icon-wrapper' : ''}>
									{title.icon && (
										<span className={`o-header__title-icon o-header__title-icon--${title.icon}`}>
											<Icon iconName={title.icon} />
										</span>
									)}
									<span className="o-header__title-day">
										{title.dayOfMonth ? `${title.dayOfMonth}` : ''}
									</span>
								</div>
								{` ${title.text}`}
							</span>
						</div>
					)}

					<div className="container">
						<div className="row">
							<div className="col-xs-12">
								<div className="o-header__logo">
									<UIAsset src={`/img/svg/logo_coach.svg`} alt="" />
								</div>
								<div className="o-header__nav">
									<HeaderNav />
								</div>
								<div className="o-header__service">
									<HeaderService />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default memo(Header, (prevProps, nextProps) => {
	return (
		prevProps.title === nextProps.title &&
		prevProps.showOffCanvasTrigger === nextProps.showOffCanvasTrigger &&
		prevProps.currentViewId === nextProps.currentViewId &&
		prevProps.dayNumber === nextProps.dayNumber
	);
});
